module.exports = __webpack_public_path__ + "static/media/Event-03.6c37960f.svg";